export default "__VITE_ASSET__b1092Tv___"